<template>
  <aside :class="(isOpen ? '' : 'mobile-menu-not-open ')">
    <router-link
      :to="{ name: 'home' }"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/dashboards.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.dashboards') }}
      </div>
    </router-link>

    <router-link
      :to="{name: 'profile'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/profile.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.profile') }}
      </div>
    </router-link>

    <router-link
      v-if="$store.state.user.profile.type === 'influencer'"
      :to="{name: 'channels'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/channels.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.channels') }}
      </div>
    </router-link>

    <router-link
      v-if="$store.state.user.profile.type === 'advertiser'"
      :to="{name: 'search'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/search.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.search') }}
      </div>
    </router-link>

    <router-link
      :to="{name: 'campaigns'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon position-relative"
        :style="`background-image: url(${$publicPath}img/menu-icons/campaigns.svg)`"
      >
        <message-marker v-if="hasUnread" />
      </div>
      <div>
        {{ $t('navigation.link-name.menu.campaigns') }}
      </div>
    </router-link>

    <router-link
      :to="{name: 'campaigns-cpc'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/campaigns-cpc.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.campaigns-cpc') }}
      </div>
    </router-link>

    <router-link
      :to="{name: 'payments'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/payments.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.payments') }}
      </div>
    </router-link>

    <router-link
      v-if="$store.state.user.profile.type === 'advertiser'"
      :to="{name: 'favlist'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/favlist.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.favlist') }}
      </div>
    </router-link>

    <router-link
      :to="{name: 'faq'}"
      @click.native="toggleMenu"
    >
      <div
        class="nav-icon"
        :style="`background-image: url(${$publicPath}img/menu-icons/faq.svg)`"
      />
      <div>
        {{ $t('navigation.link-name.menu.faq') }}
      </div>
    </router-link>
  </aside>
</template>

<script>
import MessageMarker from './MessageMarker.vue'

export default {
  components: {
    'message-marker': MessageMarker
  },
  computed: {
    isOpen () {
      return this.$store.state.mobileMenu.isOpen
    },
    hasUnread () {
      return this.$store.getters['campaignsMessages/hasUnread']
    }
  },
  methods: {
    toggleMenu (e) {
      this.$store.dispatch('mobileMenu/toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
  aside {
    box-shadow: 0px 5px 30px 10px rgba(140, 178, 200, 0.05);
    padding: 1.5rem 0.5rem;
    background-color: white;
    text-align: center;
    display: flex;
    flex-direction: column;
    z-index: 1;
  }
  a {
    color: black;
    font-size: 0.813rem;
    font-weight: 500;
    display: inline-block;
    transition: 0.3s;
    margin-bottom: 1.6rem;
    text-decoration: none !important;
    &:hover .nav-icon {
      border-color: $warning;
    }
  }
  .nav-icon {
    width: 54px;
    height: 54px;
    margin: 0 auto 0.5rem auto;
    border-radius: 10px;
    border: 2px solid #EBECF0;
    background-repeat: no-repeat;
    background-position: center;
    transition: 0.2s;
  }
  .router-link-active {
    .nav-icon {
      border-color: $warning;
    }
  }
  .mobile-menu-not-open {
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
</style>
